import Order from '../Order/order';

export default Order;